import { GeoJsonPolygon } from './geojson';

export function geoJsonPolygonToPostGis(polygon: GeoJsonPolygon): string {
  const coordinates = polygon.coordinates[0];
  const points = coordinates.map((coord) => `${coord[0]} ${coord[1]}`).join(', ');
  return `POLYGON((${points}))`;
}

export function postGisToGeoJsonPolygon(postgis: string): GeoJsonPolygon {
  const match = postgis.match(/POLYGON\(\(([^)]+)\)\)/);
  if (!match) {
    throw new Error('Invalid PostGIS POLYGON format');
  }

  const points = match[1]
    .split(',')
    .map((point) => {
      const [lng, lat] = point.trim().split(' ').map(Number);
      return [lng, lat];
    });

  return {
    type: 'Polygon',
    coordinates: [points],
  };
}

export function parsePostGISPoint(pointString: string | null | undefined): {
  latitude: number;
  longitude: number;
} | null {
  if (!pointString || typeof pointString !== 'string') {
    return null;
  }

  try {
    const match = pointString.match(/POINT\(([^)]+)\)/);
    if (!match) {
      return null;
    }

    const coords = match[1]
      .trim()
      .split(/\s+/)
      .map((s) => parseFloat(s.trim()));

    if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
      return {
        longitude: coords[0],
        latitude: coords[1],
      };
    }

    return null;
  } catch (error) {
    console.warn(`Failed to parse PostGIS point: ${pointString}`, error);
    return null;
  }
}
